import { render, staticRenderFns } from "./tablData.vue?vue&type=template&id=4e9685e7"
import script from "./tablData.vue?vue&type=script&lang=js"
export * from "./tablData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports